<template>
  <b-row class="justify-content-xl-center">
    <b-col class="col-xl-10" v-if="school.name">
      <h3>Einladung annehmen</h3>

      <p>
        Sie wurden eingeladen im Team "<strong>{{ school.name }}</strong>" mitzuarbeiten. Bitte füllen Sie die fehlenden Informationen
        aus, dann kann es direkt losgehen.
      </p>
      <registrationForm v-bind:registration="registration"></registrationForm>
    </b-col>
  </b-row>
</template>

<script>

import Form from './Form'

export default {
  name: 'join',

  components: {
    'registrationForm': Form
  },

  data () {
    return {
      registration: {
        firstname: '',
        lastname: '',
        password: '',
        token: ''
      },
      school: {
        name: ''
      },
      step: 0
    }
  },

  mounted: function () {
    this.registration.token = this.$route.query.token
    this.loadInvitation()
  },

  methods: {
    loadInvitation: function () {
      this.axios.get('/registration/' + this.registration.token)
        .then((rsp) => {
          this.$set(this, 'school', rsp.data)
        })

        .catch((e) => {
          if (e.response && e.response.status === 404) {
            this.$eventHub.$emit('error', 'Der Code ist entweder ungültig oder die Einladung wurde bereits angenommen.')
          }
        })
    },

    send: function () {
      this.axios.post('/registration', JSON.stringify(this.registration)).then((rsp) => {
        this.$eventHub.$emit('auth', rsp, 'invitation')
      }).catch((err) => {
        this.$eventHub.$emit('error', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/views/guests/registration/Join.vue